import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { isEmpty, last, sortBy } from 'lodash';
import { theme } from '../../../../tailwind.config';
import { hooks } from '../../../config/api';
import { RejectionContent } from './RejectionContent';
import ToolTip from '../../common/ToolTip/ToolTip';
export var RejectionToolTip = function RejectionToolTip(_ref) {
  var _context, _context2, _insurance$plan$payer, _data$data;
  var insurance = _ref.insurance;
  if (!_includesInstanceProperty(_context = ['rejected', 'enrolled']).call(_context, insurance === null || insurance === void 0 ? void 0 : insurance.insurance_status)) {
    return null;
  }
  var enrollmentRequestIds = _mapInstanceProperty(_context2 = insurance.enrollment_requests).call(_context2, function (request) {
    return request.id;
  }).join(',');
  if (isEmpty(enrollmentRequestIds)) {
    return null;
  }
  var _hooks$useFind = hooks.useFind('enrollment_requests', {
      id: enrollmentRequestIds,
      'plan.payer': (_insurance$plan$payer = insurance.plan.payer) === null || _insurance$plan$payer === void 0 ? void 0 : _insurance$plan$payer.id
    }),
    data = _hooks$useFind.data;
  var enrollmentRequests = (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data) || {};
  if (isEmpty(enrollmentRequests)) {
    return null;
  }
  var enrollmentRequest = last(sortBy(enrollmentRequests, 'updated_at'));
  if (enrollmentRequest.enrollment_status !== 'rejected') {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mr-2"
  }, /*#__PURE__*/React.createElement(ToolTip, {
    tooltipContent: /*#__PURE__*/React.createElement(RejectionContent, {
      enrollmentRequest: enrollmentRequest
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconInfoCircle",
    color: theme.extend.colors['dark-blue'],
    ariaLabel: "rejection-info-icon"
  })));
};
RejectionToolTip.propTypes = {
  insurance: PropTypes.object.isRequired
};
//# sourceMappingURL=RejectionToolTip.js.map